import utils = egr.wcf.utils;
import { extendQueryString, parseQueryString } from '../submodules/utils/Url';
import { Dict } from '../submodules/utils/Types';
import { loadHiddenFrame } from '../submodules/utils/Download';

declare var KJUR: any;
declare var KEYUTIL: any;

const ConfigUrl: string = 'https://blancfischer.ice.ibmcloud.com/oidc/endpoint/default/.well-known/openid-configuration';
const ClientId: string = 'b81d2407-aafa-4afd-974f-68b2f6e5dbee';
const Scope: string = 'openid profile';
const ResponseType: string = 'token id_token';
const Nonce: string = '12345';

interface OpenidConfiguration {
    issuer: string;
    jwks_uri: string;
    authorization_endpoint: string;
    end_session_endpoint: string;
}

interface WebKey {
    kid: string;
    use: string;
    kty: string;
    e: string;
    n: string;
}

interface WebKeyResponse {
    keys: Array<WebKey>;
}

interface ParsedTokenHeader {
    alg: string;
    kid: string;
    typ: string;
}

interface ParsedTokenPayload {
    nonce: string;
}

interface ParsedToken {
    headerObj: ParsedTokenHeader;
    payloadObj: ParsedTokenPayload;
}

export interface Payload {
    nonce: string;
}

let configCache: OpenidConfiguration | null = null;
async function getOpenifConfiguration(): Promise<OpenidConfiguration> {
    if (configCache == null) {
        configCache = await utils.async.ajax<OpenidConfiguration>('GET', ConfigUrl);
    }

    return configCache;
}

function getRedirectUrl(): string {
    return document.location.href.split('#')[0];
}

async function decodePayload<T extends Payload>(token: string, nonce: string, gracePeriod: number = 3600): Promise<T | null> {
    const config: OpenidConfiguration = await getOpenifConfiguration();
    const data: ParsedToken = KJUR.jws.JWS.parse(token);

    const webKeyResponse: WebKeyResponse = await utils.async.ajax<WebKeyResponse>('GET', config.jwks_uri);
    const [webKey] = webKeyResponse.keys.filter((value: WebKey): boolean => {
        return value.kid === data.headerObj.kid;
    });

    if (webKey != null) {
        const publicKey: string  = KEYUTIL.getKey(webKey);
        const validSignature: boolean = KJUR.jws.JWS.verifyJWT(
            token,
            publicKey,
            {
                iss: [config.issuer],
                alg: [data.headerObj.alg],
                gracePeriod: gracePeriod,
            }
        );

        if (validSignature && data.payloadObj.nonce === nonce) {
            return data.payloadObj as T;
        }
    }

    return null;
}

export function getUserInfo<T extends Payload>(): Promise<T | null> {
    const args: Dict = parseQueryString(window.location.hash.substr(1));
    if (!utils.string.isNullOrEmpty(args.id_token)) {
        return decodePayload(args.id_token, Nonce);
    }

    return Promise.resolve<null>(null);
}

export async function login(): Promise<void> {
    const config: OpenidConfiguration = await getOpenifConfiguration();
    const loginUrl: string = extendQueryString(
        config.authorization_endpoint,
        {
            redirect_uri: getRedirectUrl(),
            response_type: ResponseType,
            client_id:  ClientId,
            scope: Scope,
            nonce: Nonce,
            state: '12345'
        }
    );
    document.location.href = loginUrl;

    return new Promise<void>((): void => {
        // never resolve
    });
}

export function logout(): void {
    loadHiddenFrame('https://blancfischer.ice.ibmcloud.com/idaas/mtfim/sps/idaas/logout', 5000);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/OpenID.ts